import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { TableData } from '../md/md-table/md-table.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserService } from '../services/user.service';
import { User } from '../models/user';
import swal from 'sweetalert2';
import {Icon} from '../models/card-icon'
import { MatDialogModule } from '@angular/material/dialog';

declare const require: any;

declare const $: any;

@Component({
    selector: 'app-userchangepassword-cmp',
    templateUrl: 'userchange-password.component.html',
    providers: [UserService
    
    ]
})

export class UserChangePasswordComponent implements OnInit, AfterViewInit {
  icon: Icon = {
    icon: 'perm_identity',
    title: 'Change Password',
  }
  public identity;
  public token;
  public privilegio;
	
   public loading;
 
   public idPaciente;

   //public user: User;
   public user;

  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public status_user;
  password2: string = '';
  password1: string = '';
 
 

     constructor(public dialogRef: MatDialogRef<UserChangePasswordComponent>,public dialog: MatDialog, private _userService: UserService, 
     
      private _route: ActivatedRoute,
      private _router: Router) {
      this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

console.log(this.identity);

//this.user = this.identity;
     // this.showSwal('welcome');
 this.user = {
      name: "loading",
      surname: '...'
    }
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
     ngOnInit() {

     if(this.identity == null && this.identity.sub){
      localStorage.clear();
    /*   this._router.navigate(['/pages/lock']); */
    } else {
      
this.getUser();
  }


   }

  

     ngAfterViewInit() {

 var self = this; // get a reference to `this`

      

    }


  onSubmit(){
    this.user.password = this.password1;
    console.log(this.user);
    this._userService.chPassword(this.user).subscribe(
        response => {
          console.log(response);
          this.status_user = response.status;
          console.log(this.status_user);
          if(this.status_user != 'success'){
            this.status_user = 'error';
          } else {
            this.user = response.user;
           
            //this._router.navigate(['/tables/listfiles']);
         
           
          }
        },
        error => {
          console.log(<any>error);
        }
      );
  }

   


  getUser(){
    this.loading = 'show';
    this._route.params.forEach((params: Params) => {
      let id =+ params['id'];
     

      this._userService.getUser(this.token, id).subscribe(
        response => {
          
          if(response.status == 'success'){
           
              this.user = response.data;
             
              this.loading = 'hide';
            
          } else {
            localStorage.clear();
            /* this._router.navigate(['/pages/lock']); */
          }
        },
        error => {
          console.log(<any>error);
        }
      );
    });
  }


showSwal(type) {
      if (type === 'success-changed') {
            swal.fire({
              
                title: 'Password has been changed!',
                text: ' password has been changed.',
                buttonsStyling: false,
             
                customClass:{
    confirmButton: 'btn btn-success'
            },

            });

        } else  if (type === 'welcome') {
            swal.fire({
           
                title: 'Welcome to GreenTek Solutions, LLC Dashboard',
                text: 'Please change your password',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },

            });

        } 
    }




	
}
